import React, { useState, useEffect } from 'react';
import { TrashIcon } from '../../../../../../img/findcare/FindCareSVG';
import { maskTaxIDString } from 'src/common/masking';

const DoctorViewListItem = ({
  doctor,
  onDeleteClick,
  showDoctorTrashIcon,
  maskTaxId = false,
}) => {
  const [doctorSpecialty, setDoctorSpecialty] = useState([]);

  const IconDoctor = () => (
    <svg
      width="17"
      height="19"
      viewBox="0 0 17 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6938 14.3565C16.3117 12.9455 15.5536 12.15 14.1375 11.7447C14.1375 11.7447 13.1398 11.4399 12.318 11.1656C12.0758 10.8737 11.7169 10.7049 11.3385 10.7054H11.2294C11.1887 10.5131 11.1703 10.3168 11.1748 10.1202C11.693 9.59197 12.0426 8.92022 12.1785 8.19102C12.4884 8.05203 12.7239 7.78548 12.8244 7.45961C12.9458 7.17746 12.9651 6.86154 12.879 6.56659C13.5341 4.96953 13.3278 3.01607 12.4332 2.3882C11.9878 1.53298 11.2036 0.906452 10.274 0.663322C9.07055 0.325367 7.78089 0.517041 6.72617 1.19057C3.77856 3.09836 4.92789 6.14003 5.15843 6.67642C5.11135 6.94027 5.14096 7.21213 5.24328 7.45965C5.34544 7.77974 5.57806 8.04122 5.88308 8.17886C6.01175 8.87606 6.33708 9.5213 6.82022 10.038C6.82836 10.2621 6.80793 10.4865 6.75951 10.7054C6.40119 10.701 6.05796 10.8507 5.81646 11.1169C5.25853 11.2998 4.52767 11.5314 3.84538 11.7447C2.42926 12.1501 1.66505 12.9455 1.28289 14.3566C1.28289 14.4023 1.26172 14.445 1.25253 14.4907L0.997855 15.9261V15.9537C0.96528 16.3175 1.08744 16.6782 1.33427 16.9465C1.58095 17.2148 1.92919 17.3657 2.29271 17.3617H2.77187L2.70509 17.7822C2.6663 18.0336 2.74078 18.2894 2.90824 18.4802C3.11125 18.6857 3.39067 18.7962 3.67848 18.7849H4.09707C4.26454 18.7849 4.40032 18.6485 4.40032 18.4802C4.40032 18.3118 4.26454 18.1754 4.09707 18.1754H3.66946C3.54923 18.1828 3.43107 18.141 3.34193 18.0595C3.29322 17.9977 3.27234 17.9181 3.28434 17.8401L3.36622 17.3373H8.16354L8.24838 17.8432C8.26067 17.9099 8.24172 17.9784 8.197 18.0291C8.10994 18.1229 7.98793 18.1758 7.8603 18.1754H7.4389C7.27129 18.1754 7.13566 18.3118 7.13566 18.4802C7.13566 18.6485 7.27129 18.7849 7.4389 18.7849H7.86045C8.16295 18.7883 8.4517 18.6592 8.65188 18.4313C8.80958 18.2467 8.87635 18.0005 8.83371 17.7608L8.76693 17.3554L15.693 17.3555C16.0564 17.36 16.4048 17.2094 16.6513 16.9409C16.897 16.6717 17.0191 16.3113 16.9879 15.9475L16.7211 14.4693L16.6938 14.3565ZM12.3119 14.323C12.4936 14.323 12.6681 14.3956 12.7966 14.5248C12.9252 14.654 12.9973 14.8291 12.9973 15.0117C12.9973 15.1945 12.9252 15.3696 12.7966 15.4988C12.6681 15.6279 12.4937 15.7006 12.312 15.7006C12.1302 15.7006 11.9559 15.628 11.8274 15.4988C11.6989 15.3696 11.6266 15.1945 11.6266 15.0117C11.6266 14.8291 11.6989 14.654 11.8274 14.5248C11.9559 14.3956 12.1301 14.323 12.3119 14.323ZM12.2604 7.25541C12.21 7.41509 12.1019 7.55007 11.9573 7.63325L11.654 7.56316L12.1483 6.90482C12.1869 6.84753 12.2375 6.79976 12.2968 6.76479C12.3415 6.92759 12.3285 7.10094 12.2604 7.25541ZM7.03546 1.70556C7.94534 1.12578 9.05673 0.959714 10.0951 1.24841C10.8881 1.45436 11.5523 1.99738 11.9146 2.73564L11.954 2.81794L12.0328 2.86675C12.6393 3.21423 12.8757 4.77453 12.3815 6.16131C12.3342 6.15372 12.2863 6.15372 12.239 6.16131C12.3148 5.71634 12.4453 4.66485 12.0964 4.1315C11.9861 3.95992 11.811 3.84102 11.6114 3.80233L11.3354 3.74444L11.2656 4.01871C11.1322 4.53689 10.6591 4.57335 9.14292 4.60996H8.80029C7.61457 4.64344 5.82546 4.69225 5.82546 6.0911V6.1734C5.74477 6.1536 5.66051 6.1536 5.57982 6.1734C5.28575 5.36579 4.77019 3.16849 7.03546 1.70556ZM6.08323 7.63333C5.93442 7.55505 5.82471 7.41815 5.77999 7.25549C5.70684 7.10281 5.68967 6.929 5.73142 6.76485C5.79065 6.79982 5.84144 6.84774 5.88009 6.90503L6.37744 7.56634L6.08323 7.63333ZM6.41372 7.60595V6.0821C6.41372 5.39934 7.29309 5.24101 8.81242 5.19831H9.15505C10.4589 5.16482 11.2778 5.14339 11.6598 4.58877C11.8024 4.98489 11.7205 5.78655 11.6233 6.2437V7.62736L11.6384 7.60608L11.6112 7.91085C11.4899 9.23663 10.2284 10.5349 9.06089 10.5349H8.98211C7.8177 10.5349 6.55616 9.23663 6.4318 7.91085L6.41372 7.60595ZM2.28354 16.7643C2.08809 16.7684 1.9002 16.6893 1.76621 16.5464C1.6322 16.4035 1.56454 16.2104 1.57993 16.0145L1.83772 14.5974L1.85594 14.5121C2.18643 13.2931 2.78996 12.6835 4.01507 12.3147L5.47978 11.8546C5.47667 11.8982 5.47652 11.942 5.47963 11.9856V13.7441C4.86086 13.8079 4.28026 14.0752 3.82793 14.5044C3.37557 14.9337 3.0768 15.501 2.97787 16.1183L2.8717 16.7644L2.28354 16.7643ZM3.4632 16.7643L3.55115 16.2126C3.63614 15.6855 3.90474 15.2062 4.30911 14.8599C4.71364 14.5138 5.22745 14.3234 5.75869 14.3231C6.291 14.3221 6.80614 14.5117 7.21184 14.858C7.61754 15.2043 7.88716 15.6846 7.9723 16.2128L8.06025 16.7644L3.4632 16.7643ZM16.2146 16.5418C16.0796 16.6866 15.8902 16.7673 15.693 16.7643H8.66982L8.57891 16.1183C8.48 15.501 8.1812 14.9337 7.72899 14.5044C7.27663 14.0752 6.69607 13.808 6.07715 13.7441V11.9856C6.069 11.8619 6.09521 11.7384 6.15296 11.629C6.44672 11.5444 6.7353 11.4426 7.01724 11.3243C7.05514 11.3018 7.08905 11.2729 7.11733 11.2389C7.12666 11.2335 7.13495 11.2262 7.14147 11.2176C7.15035 11.2058 7.15835 11.1936 7.16575 11.181C7.17967 11.1656 7.19092 11.1482 7.19921 11.1292C7.29472 10.9576 7.35261 10.7674 7.3689 10.5714C7.83711 10.9176 8.40107 11.1082 8.98224 11.117H9.06101C9.6142 11.1039 10.1508 10.9244 10.6015 10.6019C10.619 10.8148 10.6933 11.0192 10.8168 11.1931L10.835 11.2144C10.867 11.2509 10.9037 11.2826 10.9442 11.3089C11.1817 11.4213 11.4282 11.5131 11.6811 11.5832L11.9297 11.6655C11.9821 11.7588 12.0111 11.8634 12.0147 11.9702V13.7532C11.6079 13.8535 11.2763 14.1481 11.1275 14.5416C10.9786 14.9349 11.0317 15.3767 11.2695 15.7232C11.5071 16.0696 11.8992 16.2765 12.3179 16.2765C12.7367 16.2765 13.1286 16.0696 13.3664 15.7232C13.604 15.3767 13.6572 14.9349 13.5084 14.5416C13.3596 14.1481 13.0279 13.8535 12.6212 13.7532V11.9825V11.885L13.9887 12.3177C15.2017 12.6682 15.8082 13.2838 16.1387 14.4999L16.4176 16.0238C16.4243 16.2172 16.3508 16.405 16.2146 16.5418Z"
        fill="#884EA2"
      />
    </svg>
  );

  const addIndicator = (str, n) => {
    if (str.indexOf(',') > -1) {
      const strArr = str.split(',');
      return strArr.length > n
        ? strArr.slice(0, n).join(',')
        : strArr.join(',');
    } else {
      return str;
    }
  };

  useEffect(() => {
    const str = doctor.Specialty;
    if (str.indexOf(',') > -1) {
      const strArr = str.split(',');
      setDoctorSpecialty(strArr);
    }
  }, [doctor.Specialty]);

  console.log('doctorSpecialty', doctorSpecialty);

  return (
    <div className="employer-container">
      <div className="employer-inner-container">
        <div className="w-100 justify-content-between d-flex align-items-center">
          <div className="flex-1 d-flex">
            <div className="doctor-icon">
              <IconDoctor />
            </div>
            <div>
              <div>
                {doctor.FirstName}, {doctor.LastName}{' '}
                {doctor.Qualification !== null
                  ? `,${doctor.Qualification}`
                  : ''}
              </div>
              <div className="blob-item-desc-1">
                {doctor.Specialty && (
                  <>
                    <span>{addIndicator(doctor.Specialty, 2)}</span>{' '}
                    {doctorSpecialty &&
                    doctorSpecialty.length > 0 &&
                    doctorSpecialty.length - 2 !== 0 ? (
                      <span className="moreSpecialty">
                        +{doctorSpecialty.length - 2}
                      </span>
                    ) : (
                      ''
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
          <div>
            <div className="d-dlex pt-2">
              <div className="blob-item-desc-2" style={{ textAlign: 'right' }}>
                {doctor.NationalProviderId
                  ? `NPI: ${doctor.NationalProviderId}`
                  : ''}
              </div>
              <div className="blob-item-desc-3" style={{ textAlign: 'right' }}>
                {doctor.TaxID && (
                  <div className="blob-item-desc-3">
                    {doctor.TaxID && (
                      <span>
                        Tax ID:{' '}
                        {maskTaxId
                          ? maskTaxIDString(doctor.TaxID)
                          : doctor.TaxID}
                      </span>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {showDoctorTrashIcon && (
          <div className="d-flex justify-content-center align-items-center">
            <button
              type="button"
              className="trash-button"
              onClick={onDeleteClick}
            >
              <TrashIcon />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(DoctorViewListItem);
